import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth/login';
import settings from './settings/settings';
import alert from "./shared/alert";
import car from "./car/car";
import spinner from './shared/spiner';
import systemBar from "./shared/systemBar";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
    },
    modules: {
        settings,
        systemBar,
        alert,
        spinner,
        auth,
        car,
    },
    getters: {
    }
})
